import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, Spinner, Button } from "reactstrap"
import { useParams, useNavigate } from "react-router-dom"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import seoApi from "Api/seoApi"
import { InputText } from "primereact/inputtext"
import "./ViewSeo.scss"

const ViewSeo = () => {
  document.title = "View SEO"
  const { id } = useParams()
  const navigate = useNavigate()
  const [seoDetails, setSeoDetails] = useState(null)
  const [loading, setLoading] = useState(true)
  const accessToken = localStorage.getItem("accessToken")

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "SEO", link: "/seo" },
    { label: "View SEO", link: "#" },
  ]

  useEffect(() => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    seoApi
      .getSeoById(id, config)
      .then(response => {
        if (response.data.success) {
          setSeoDetails(response.data.data)
          setLoading(false)
        }
      })
      .catch(error => {
        console.log("Error fetching SEO details:", error)
        setLoading(false)
      })
  }, [id, accessToken])

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner color="primary" />
      </div>
    )
  }

  return (
    <div className="view-seo">
      <Row>
        <Col xs="12">
          <div className="seo-list-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="View SEO" />
            <Button
              color="secondary"
              className="waves-effect"
              onClick={() => navigate("/seo")}
            >
              <i className="ion ion-md-arrow-back me-2"></i>
              Back
            </Button>
          </div>

          <Card className="mt-4">
            <CardBody>
              <h5 className="border-bottom pb-2 mb-4">SEO Details</h5>
              
              <div className="seo-view-form">
                <div className="seo-view-inp">
                  <label htmlFor="pageName" className="label">
                    Page Name
                  </label>
                  <InputText
                    id="pageName"
                    value={seoDetails?.pageName}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="seo-view-inp">
                  <label htmlFor="title" className="label">
                    Title
                  </label>
                  <InputText
                    id="title"
                    value={seoDetails?.title}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="seo-view-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <InputText
                    id="description"
                    value={seoDetails?.description}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="seo-view-inp">
                  <label htmlFor="keywords" className="label">
                    Keywords
                  </label>
                  <InputText
                    id="keywords"
                    value={seoDetails?.keywords}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="seo-view-inp">
                  <label htmlFor="schema" className="label">
                    Schema
                  </label>
                  <pre className="schema-code">
                    {JSON.stringify(seoDetails?.schema, null, 2)}
                  </pre>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ViewSeo 